import { createFusionTheme, TSITheme } from '@fusion/saas-components-v3'

export const fusionTheme = createFusionTheme(TSITheme)
